import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import Circle from 'components/common/Circle/Circle'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import CompareTrayItem from '../CompareTrayItem'

const CompareTrayDesktop = ({
  compareItems,
  disableCompare,
  items,
  itemsCount,
  toggleCompareTray
}) =>
  <Wrapper>
    <Content>
      <Products>
        {
          items.map((data = {}, index) =>
            <CompareTrayItem key={ `${data.skuId}-${index}` } { ...data } />
          )
        }
      </Products>
      <Controls>
        <Compare
          data-at-comparetray-compare
          stacked
          narrow
          full
          disabled={ disableCompare }
          onClick={ compareItems }>
          Compare
          <CircleIcon>
            <Count>{ itemsCount }</Count>
          </CircleIcon>
        </Compare>
        <Button
          data-at-comparetray-close
          stacked
          full
          narrow
          secondary
          onClick={ () => toggleCompareTray() }>
          Close
        </Button>
      </Controls>
    </Content>
  </Wrapper>

export default CompareTrayDesktop

CompareTrayDesktop.propTypes = {
  compareItems: PropTypes.func,
  disableCompare: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape()),
  itemsCount: PropTypes.number,
  toggleCompareTray: PropTypes.func
}

const Wrapper = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  height: 140px;
  background-color: ${Theme.colors.off_white};
  z-index: 20;
`

const Content = styled.div`
  height: 100%;
  margin: 0 auto;
  padding: 0 3.6%;
`

const Compare = styled(Button)`
  padding: 7px 30px 4px;
  ${Media.mobile`
    margin-top: 10px;
  `}
`

const Products = styled.div`
  display: inline-block;
  width: 75.15%;
  height: 100%;
`

const Controls = styled.div`
  display: inline-block;
  min-width: 24.85%;
  padding: 25px 4.15%;
  vertical-align: top;

  button:first-child {
    margin-bottom: 20px;
  }
`

const CircleIcon = styled(Circle)`
  display: inline-block;
  position: relative;
  top: -1px;
  width: 20px;
  height: 18px;
  padding: 0;
  margin-left: 6px;
  color: ${Theme.colors.bright_red_new};
  background-color: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.bright_red_new};
  vertical-align: middle;
`

const Count = styled.span`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 1px;
  ${Mixin.font.GothamBold(12)}
`
